export default "__VITE_ASSET__C_DHJr$t__"